import $ from 'jquery'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.partner-gallery')

  if (!wrapper.length) {
    return
  }

  new Swiper(wrapper[0], {
    grabCursor: true,
    slidesPerView: 3,
    spaceBetween: 10,
    initialSlide: 0,
    navigation: {
      nextEl: $block.find('.partner-gallery__nav--next')[0],
      prevEl: $block.find('.partner-gallery__nav--prev')[0],
    },
    breakpoints: {
      576: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 5,
      },
      992: {
        slidesPerView: 6,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  })
}

$('.partners-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=smat-partners',
    initializeBlock
  )
}
